export default class VertiGisCallback {
    mapWidgetURL;

// ****************************************************************************************
// ***************************** callback.js **********************************************
// ****************************************************************************************
// *** IN ORDER TO USE CROSS DOMAIN COMMUNICATION INCLUDE THIS FILE IN YOUR PROJECT !!! ***
// ****************************************************************************************
// ****************************************************************************************
// ***** IF CROSS DOMAIN NEEDED, PLEASE ENTER HOST-URL OF WEBOFFICE SERVER !!! ***********

    constructor() {
        if (this.mapWidgetURL === undefined) {
            this.mapWidgetURL = 'https://city-map.innsbruck.gv.at';
        }
    }

// ***************************************************************************************
// ***************************************************************************************

    XD() {

        var interval_id,
            last_hash,
            cache_bust = 1,
            attached_callback;

        return {
            postMessage: function (message, target_url, target) {

                if (!target_url)
                    return;
                target = target || parent;

                if (window['postMessage'])
                    target['postMessage'](message, target_url.replace(/([^:]+:\/\/[^\/]+).*/, '$1'));
                else if (target_url)
                    target.location = target_url.replace(/#.*$/, '') + '#' + (+new Date) + (cache_bust++) + '&' + message;
            },

            receiveMessage: function (callback, source_origin) {

                if (window['postMessage']) {
                    if (callback) {
                        attached_callback = function (e) {
                            if ((typeof source_origin === 'string' && e.origin !== source_origin)
                                || (Object.prototype.toString.call(source_origin) === "[object Function]" && source_origin(e.origin) === !1)) {
                                return !1;
                            }
                            callback(e);
                        };
                    }
                    if (window['addEventListener'])
                        window[callback ? 'addEventListener' : 'removeEventListener']('message', attached_callback, !1);
                    else
                        window[callback ? 'attachEvent' : 'detachEvent']('onmessage', attached_callback);
                } else {
                    interval_id && clearInterval(interval_id);
                    interval_id = null;

                    if (callback) {
                        interval_id = setInterval(function () {
                            var hash = document.location.hash,
                                re = /^#?\d+&/;
                            if (hash !== last_hash && re.test(hash)) {
                                last_hash = hash;
                                callback({data: hash.replace(re, '')});
                            }
                        }, 100);
                    }
                }
            }
        };
    }

    maptipResult = (message, success) => {
        window.dispatchEvent(new CustomEvent('vertigisMapttipResult', {
          detail: {
              x: message.COORDS[0].x,
              y: message.COORDS[0].y,
          }
        }))
    }

    multilayersearchResult = (multilayer, mapinfo, coordSys) =>  {
        window.dispatchEvent(new CustomEvent('vertigisLocationsUpdated', {detail: multilayer[0].REST_MULTI_LAYER_FEATURE}))
    }

    initXD() {
        let XD = this.XD();

        XD.receiveMessage( (message) => {
            let msg = message.data;

            switch (msg[0]) {
//                case "IDENTIFY":
//                    callFunction.call(null, msg[2], msg[3], msg[4], msg[5], msg[6], msg[7]);
//                    break;
//                case "CREATEPOINT":
//                    callFunction.call(null, msg[2], msg[3], msg[4], msg[5], msg[6], msg[7], msg[8]);
//                    break;
//                case "MOVEPOINT":
//                    callFunction.call(null, msg[2], msg[3], msg[4], msg[5], msg[6], msg[7], msg[8]);
//                    break;
//                case "SEARCH":
//                    callFunction.call(null, msg[2], msg[3], msg[4], msg[5], msg[6], msg[7], msg[8]);
//                    break;
//                case "SELECTLINE":
//                    callFunction.call(null, msg[2], msg[3], msg[4], msg[5]);
//                    break;
//                case "SELECTAREA":
//                    callFunction.call(null, msg[2], msg[3], msg[4], msg[5]);
//                    break;
//                case "GETVERSION":
//                    callFunction.call(null, msg[2]);
//                    break;
//                case "FTS":
//                    callFunction.call(null, msg[2], msg[3]);
//                    break;
//                case "BUFFER":
//                    callFunction.call(null, msg[2], msg[3]);
//                    break;
//                case "LOCATION":
//                    callFunction.call(null, msg[2], msg[3], msg[4], msg[5], msg[6], msg[7]);
//                    break;
                case "MAPTIP":
                    this.maptipResult(msg[2], msg[3])
                    break;
//                case "EXTCALLINFO":
//                    callFunction.call(null, msg[2]);
//                    break;
//                case "ADDREMOVE":
//                    callFunction.call(null, msg[2], msg[3], msg[4], msg[5], msg[6], msg[7], msg[8]);
//                    break;
//                case "LINKFIELD":
//                    callFunction.call(null, msg[2], msg[3], msg[4], msg[5]);
//                    break;
//                case "ERROR":
//                    callFunction.call(null, msg[2]);
//                    break;
//                case "ACTIVETOOL":
//                    callFunction.call(null, msg[2]);
//                    break;
//                case "CLICKINFO":
//                    callFunction.call(null, msg[2], msg[3], msg[4]);
//                    break;
//                case "LOGPOSITION":
//                    callFunction.call(null, msg[2], msg[3], msg[4], msg[5]);
//                    break;
//                case "IDENTIFY_LAYER":
//                    callFunction.call(null, msg[2]);
//                    break;
//                case "MEASURELINE":
//                    callFunction.call(null, msg[2], msg[3], msg[4]);
//                    break;
//                case "VIEWCHANGE":
//                    callFunction.call(null, msg[2]);
//                    break;
                case "MULTILAYERSEARCH":
                    this.multilayersearchResult(msg[2], msg[3], msg[4])
                    break;
            }

        }, this.mapWidgetURL);
    }
}
